export default __webpack_public_path__ + "static/media/3435 spice rack C side.fbbefaf4.png";